import React from 'react'
import { AddressType } from '../../redux/reducers/addressReducer'
import AreaAddress from './AreaAddressForm'
import GoogleMapAddress from './GoogleMapAddressForm'

interface AddressFormProps {
  account?: boolean
  prefill?: boolean
  defaultAddress?: any
  addressType?: 'billing' | 'shipping'
  hideAdditionalAddress: boolean
  className?: string
}

const AddressForm = ({
  account = false,
  prefill = false,
  defaultAddress = null,
  addressType = 'shipping',
  hideAdditionalAddress = false,
  className,
}: AddressFormProps) => {
  const addressFormType = process.env.ADDRESS_TYPE

  if (addressFormType === AddressType.AREA) {
    return (
      <AreaAddress
        className={className}
        prefill={prefill}
        addressType={addressType}
      />
    )
  }

  return (
    <GoogleMapAddress
      className={className}
      account={account}
      prefill={prefill}
      defaultAddress={defaultAddress}
      addressType={addressType}
      hideAdditionalAddress={hideAdditionalAddress}
    />
  )
}

export default AddressForm
